export class TransferCreditModel {
    public recipientUserId: string;
    public amount: number;
}
